import React from 'react';
//mport {useMutation, useNotify, Button } from 'react-admin';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToCreate = ({ classes, ...props}) => {

   // console.log(props)
    return <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/checklist/create',
            uid: props.uid
        }}
        className={classes.link}
       
    >
        <AddCircleIcon className={classes.icon} />Create
    </Button>
};


export default  withStyles(styles)(LinkToCreate);